import type { SyncManager } from '@wiztime/sync';
import { useCallback, useEffect, useState } from 'react';
import { useServices } from '../../hooks/useServices';

export interface ManagerState {
  readonly manager: SyncManager | null;
  readonly failed: boolean;
  readonly retry: () => void;
}

/** Loads the sync code (once per page load) and returns the manager. */
export function useSyncManager(): ManagerState {
  const { sync } = useServices();
  const [manager, setManager] = useState<SyncManager | null>(null);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let alive = true;
    sync.manager().then(
      (loaded) => {
        if (alive) setManager(loaded);
      },
      (error: unknown) => {
        console.error('[sync] could not load the sync code', error);
        if (alive) setFailed(true);
      },
    );
    return () => {
      alive = false;
    };
  }, [sync, attempt]);
  const retry = useCallback(() => {
    setFailed(false);
    setAttempt((count) => count + 1);
  }, []);
  return { manager, failed, retry };
}
